import { useState, useRef, useEffect } from 'react'
import Select from 'react-select'
import { useSelector, useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'
import DropdownToggle from './DropdownToggle'
import { parseSubjectsFromUrl } from '../../SearchUtils'
import { createDropdown, whenBootstrapReady } from '../../../helpers/bootstrap'

function MakeModelFilter({ makes }) {
  const { currentFilters } = useSelector((state) => state.items)
  const dispatch = useDispatch()

  const [selectedMake, setSelectedMake] = useState(null)
  const [currentModels, setCurrentModels] = useState([])
  const [loadingModels, setLoadingModels] = useState(false)
  const [selectedModel, setSelectedModel] = useState(null)

  const dropdownRef = useRef(null)

  useEffect(() => {
    const dropdownToggleEl = document.getElementById(
      'dropdown-filter-make_model'
    )
    return whenBootstrapReady(() => {
      dropdownRef.current = createDropdown(dropdownToggleEl)
    })
  }, [])

  const handleSubmit = () => {
    const newFilters = {
      popstate: 0,
      subjects: parseSubjectsFromUrl(),
      ...currentFilters,
    }

    if (selectedModel) {
      newFilters.manufacturer_model_id = newFilters.manufacturer_model_id || []

      if (!newFilters.manufacturer_model_id.includes(selectedModel.value)) {
        newFilters.manufacturer_model_id = [
          ...newFilters.manufacturer_model_id,
          selectedModel.value,
        ]
      }
    } else if (selectedMake) {
      newFilters.manufacturer_id = newFilters.manufacturer_id || []

      if (!newFilters.manufacturer_id.includes(selectedMake.value)) {
        newFilters.manufacturer_id = [
          ...newFilters.manufacturer_id,
          selectedMake.value,
        ]
      }
    }

    delete newFilters.page

    setSelectedModel(null)
    setCurrentModels([])
    setSelectedMake(null)

    dropdownRef.current?.toggle()

    dispatch(itemsFetchData({ filters: newFilters }))
  }

  const changeMake = (make) => {
    setSelectedMake(make)
    setLoadingModels(true)

    App.Request.get('/manufacturer_models/select_options.json', {
      params: {
        manufacturer_id: make.value,
        with_count: 1,
        published_zero_desc: 1,
      },
    }).then(({ status, data }) => {
      if (status === 200) {
        setCurrentModels(data.models || [])
        setLoadingModels(false)
      }
    })
  }

  return (
    <div className="dropdown d-block">
      <DropdownToggle
        name="make_model"
        title={I18n.t('search.filters.make_models.title')}
      />
      <div
        className="dropdown-menu w-100 p-2"
        id="dropdown-menu-filter-make_model"
        aria-labelledby="filter-make_model"
      >
        <form>
          <div className="mb-3">
            <label htmlFor="carmake">
              {I18n.t('search.filters.make_models.make_title')}
            </label>
            <Select
              inputId="carmake"
              inputProps={{ type: 'text' }}
              options={makes}
              onChange={changeMake}
              value={selectedMake}
              placeholder={`${I18n.t('select')}...`}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="carmodel">
              {I18n.t('search.filters.make_models.model_title')}
            </label>
            <Select
              inputId="carmodel"
              inputProps={{ type: 'text' }}
              options={currentModels}
              isDisabled={loadingModels}
              value={selectedModel}
              onChange={setSelectedModel}
              placeholder={`${I18n.t('select')}...`}
            />
          </div>
          <button
            className="btn btn-primary d-block mt-2 w-100"
            type="button"
            onClick={handleSubmit}
            disabled={!selectedMake}
          >
            {I18n.t('submit')}
          </button>
        </form>
      </div>
    </div>
  )
}

export default MakeModelFilter
